import { TableContainer, Separator } from "../../styles";
import { DadosPendenciaFinalizada } from "../../types";
import { formatTipo } from "../../../../../../../../../utility/pendenciaTipos";

interface BlocoPendenciasFinalizadasProps {
    pendencias: DadosPendenciaFinalizada[];
}

const formatValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
};

export default function BlocoPendenciasFinalizadas({ pendencias }: BlocoPendenciasFinalizadasProps) {
    if (!pendencias || pendencias.length === 0) {
        return null;
    }

    return (
        <>
            {pendencias.map((pendencia, index) => (
                <div key={pendencia.id_pendencia} className="expanded-section">
                    {index === 0 && <Separator />}
                    <h4 className="section-title">
                        Pendência #{String(pendencia.id_pendencia).padStart(4, '0')}
                        {pendencia.tipo && pendencia.tipo !== '—' && (
                            <span style={{ marginLeft: '8px', color: 'var(--c64748b)', fontWeight: 'normal' }}>
                                ({formatTipo(pendencia.tipo)})
                            </span>
                        )}
                    </h4>
                    <TableContainer>
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th className="field-col">Campo</th>
                                    <th className="before-col">Antes</th>
                                    <th className="after-col">Depois</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pendencia.campos.map((campo, i) => (
                                    <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                        <td className="field-cell">{campo.campo}</td>
                                        <td className="before-cell">{formatValue(campo.antes)}</td>
                                        <td className="after-cell">
                                            <div className="after-content">
                                                <span className="highlight-bar" />
                                                <span>{formatValue(campo.depois)}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </TableContainer>
                </div>
            ))}
        </>
    );
}

